import React, { useEffect, useState } from 'react';
import { Link } from 'react-router-dom';
import { ExternalLinkIcon, UserIcon } from 'lucide-react';
import { PageHeader } from '../components/layout/PageHeader';
import { Card } from '../components/ui/Card';
import { Button } from '../components/ui/Button';
import { IntegrationsPanel } from '../components/settings/IntegrationsPanel';
import { TeamAccessPanel } from '../components/settings/TeamAccessPanel';
import { getPublishedWebsiteContent, websiteUpdatedEvent, type WebsiteContent } from '../data/website';
export function Settings() {
  const [content, setContent] = useState<WebsiteContent>(() => getPublishedWebsiteContent());
  useEffect(() => {
    const refresh = () => setContent(getPublishedWebsiteContent());
    window.addEventListener(websiteUpdatedEvent, refresh);
    window.addEventListener('focus', refresh);
    return () => {
      window.removeEventListener(websiteUpdatedEvent, refresh);
      window.removeEventListener('focus', refresh);
    };
  }, []);
  const details: {
    label: string;
    value: string;
    missing?: boolean;
  }[] = [{
    label: 'Band name',
    value: content.bandName || 'Not set',
    missing: !content.bandName
  }, {
    label: 'Genre',
    value: content.seoGenre || 'Not set',
    missing: !content.seoGenre
  }, {
    label: 'Home market',
    value: content.seoLocation || 'Not set',
    missing: !content.seoLocation
  }, {
    label: 'Booking email',
    value: content.bookingEmail || 'Not set',
    missing: !content.bookingEmail
  }, {
    label: 'Site address',
    value: content.siteUrl || 'Not set',
    missing: !content.siteUrl
  }];
  return <div data-id="element-1792" data-mp="krlua3ggud2s">
      <PageHeader eyebrow="Settings" title="Settings" subtitle="Who can sign in to the studio, and which outside services the site is connected to." data-id="element-1793" data-mp="krc2qbfrvxuz" />

      <div className="grid gap-6 lg:grid-cols-2" data-id="element-1794" data-mp="2mi5l16h5at6o">
        <Card className="p-6" data-id="element-1795" data-mp="2miyuwgbehyt1">
          <h3 className="mb-1.5 flex items-center gap-2 text-[15px] font-semibold text-white" data-id="element-1796" data-mp="2hjc8phdlh883">
            <UserIcon className="h-4 w-4 text-accent-soft" data-id="element-1797" data-mp="2hlowwc9y4etl" /> Band details
          </h3>
          <p className="mb-4 text-[12.5px] text-zinc-500" data-id="element-1798" data-mp="379kqpye2oa7h">
            These come from your published site. Change them in Website Studio and they update everywhere.
          </p>

          <dl className="grid gap-3 sm:grid-cols-2" data-id="element-1799" data-mp="3g6lb7ty0to5n">
            {details.map(detail => <div key={detail.label} className="rounded-xl border border-white/[0.06] bg-ink-800 px-3 py-2.5" data-id="element-1800" data-mp="3l8u28krc2g54">
                <dt className="text-[11px] text-zinc-500" data-id="element-1801" data-mp="3q63sg2mjqvu0">{detail.label}</dt>
                <dd className={`mt-0.5 truncate text-[13px] font-medium ${detail.missing ? 'text-amber-300' : 'text-white'}`} title={detail.value} data-id="element-1802" data-mp="3u6mips8sjtu3">
                  {detail.value}
                </dd>
              </div>)}
          </dl>

          <Link to="/studio/website" className="mt-4 inline-block" data-id="element-1803" data-mp="ct0nobgkbeqp">
            <Button variant="secondary" size="sm" data-id="element-1804" data-mp="hpr2kvgms4aj">
              Edit in Website Studio <ExternalLinkIcon className="h-3.5 w-3.5" data-id="element-1805" data-mp="228l425voukqs" />
            </Button>
          </Link>
        </Card>

        <TeamAccessPanel data-id="element-1806" data-mp="1x9rng4l3udme" />

        <IntegrationsPanel data-id="element-1807" data-mp="1x8giw2ju51u8" />
      </div>
    </div>;
}